var map = {
	"./aether.webp": 235,
	"./amber.webp": 324,
	"./azhdaha.webp": 799,
	"./fischl.webp": 129,
	"./hutao.webp": 342,
	"./keqing.webp": 110,
	"./lumine.webp": 797,
	"./mona.webp": 343,
	"./paimon.webp": 452,
	"./qiqi.webp": 864,
	"./rosaria.webp": 847,
	"./xiao.webp": 519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 672;